import { useState, useRef, useEffect } from "react";
import "../../_css/SearchableDropdown.css";
import { all } from "axios";

export default function SearchableDropdown({
  options = [],
  selected,
  setSelected,
  type = "text",
  allowManualEntry = true,
  color = "#FFFFFF",
  showDrpDown = true,
  placeHolder = "Select...",
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(selected || "");
  const [showAll, setShowAll] = useState(false);

  const dropdownRef = useRef(null);

  // Update search when parent changes selected
  useEffect(() => {
    setSearch(selected || "");
  }, [selected]);

  // 🔹 Filtered options (showAll overrides filtering)
  const filteredOptions = showAll
    ? options
    : allowManualEntry &&
      options?.filter((opt) => {
        return opt?.toLowerCase()?.includes(search?.toLowerCase());
      });

  const handleSelect = (option) => {
    if (option === "All classes") {
      option = "";
    }
    setSelected(option);
    setSearch(option);
    setOpen(false);
    setShowAll(false);
  };

  const handleManualInput = (e) => {
    setSearch(e.target.value);
    if (allowManualEntry) {
      setSelected(e.target.value);
    }
    // parent receives manual entry
    setShowAll(false);
  };

  // 🔹 Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
        setShowAll(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="s-dropdown" ref={dropdownRef}>
      {/* Input + Arrow */}
      <div
        className="s-dropdown-header"
        style={{ backgroundColor: color }}
        onClick={() => {
          if (!allowManualEntry) {
            setOpen(!open);
            setShowAll(!showAll);
          }
        }}
      >
        <input
          type={type}
          placeholder={placeHolder}
          className="s-dropdown-input no-spinner"
          style={{ backgroundColor: color }}
          value={search}
          onChange={handleManualInput}
          onFocus={() => allowManualEntry && setOpen(true)}
          readOnly={!allowManualEntry}
        />
        <span
          className="s-arrow"
          onClick={(e) => {
            e.stopPropagation();
            const willBeOpen = !open;
            setOpen(willBeOpen);
            setShowAll(willBeOpen); // show all when opening via arrow
          }}
        >
          {showDrpDown && (open ? "▲" : "▼")}
        </span>
      </div>

      {/* Dropdown menu */}
      {open && showDrpDown && (
        <div className="s-dropdown-menu">
          <ul>
            {
              filteredOptions.length > 0 &&
                filteredOptions.map((opt, idx) => (
                  <li key={idx} onClick={() => handleSelect(opt)}>
                    {opt}
                  </li>
                ))
              //  : (
              //  allowManualEntry && <li className="s-no-option">No options</li>
              // )
            }
          </ul>
        </div>
      )}
    </div>
  );
}
